"use strict";

var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobile_detect_1 = __importDefault(require("mobile-detect"));

var payment_1 = __importDefault(require("payment"));

var regularExpressions_1 = require("./constants/regularExpressions");

var creditCard_1 = require("./creditCard");

exports.normalizeNumberWithDecimalsInput = function (value, previousValue) {
  return regularExpressions_1.numberWithDecimalsRegex.test(value) ? value : previousValue;
};

exports.padTwo = function (number) {
  return "0".concat(number).slice(-2);
};

exports.onlyNumbers = function (value) {
  return !value ? value : value.replace(/[^\d]/g, '');
};

exports.numbersWithDecimals = function (value) {
  return !value ? value : value.replace(/[^\d,.]/g, '');
};

exports.normalizeName = function (value) {
  return !value ? value : value.replace(/[^a-zA-Z'´áéíóúÁÉÍÓÚñÑ ]/g, '');
};

exports.onlyLettersAndSpaces = function (value) {
  return !value ? value : value.replace(/[^a-zA-Z ]/gi, '');
};

exports.onlyLetters = function (value) {
  return !value ? value : exports.onlyLettersAndSpaces(value).replace(/[ ]/gi, '');
};

exports.normalizeDate = function (value) {
  if (!value) return value;
  var onlyNums = exports.onlyNumbers(value);
  var day = onlyNums.slice(0, 2);
  var month = onlyNums.slice(2, 4);
  var deviceDetector = new mobile_detect_1.default(window.navigator.userAgent);

  if (!deviceDetector.phone()) {
    if (onlyNums.length < 3) return day;
    if (onlyNums.length === 3) return "".concat(day, "/").concat(onlyNums.slice(2));
    if (onlyNums.length === 4) return "".concat(day, "/").concat(month);
    if (onlyNums.length === 5) return "".concat(day, "/").concat(month, "/").concat(onlyNums.slice(4));
    return "".concat(day, "/").concat(month, "/").concat(onlyNums.slice(4, 8));
  }

  if (onlyNums.length === 8) return "".concat(day, "/").concat(month, "/").concat(onlyNums.slice(4));
  if (onlyNums.length > 8) return "".concat(day, "/").concat(month, "/").concat(onlyNums.slice(4, 8));
  return value.replace(/[^\d\u002F]/g, '');
};

exports.normalizeAccount = function (value, accountLength) {
  return !value ? value : exports.onlyNumbers(value).slice(0, accountLength);
};

exports.normalizeLowerCase = function (value) {
  return !value ? value : value.toLowerCase();
};

exports.numberMaxLength = function (length) {
  return function (value) {
    return !value ? value : exports.onlyNumbers(value).slice(0, length);
  };
};

exports.withoutNumbers = function (value) {
  return !value ? value : value.replace(/[\d]/, '');
};

function formatCreditCardNumber(value) {
  if (!value) return value;
  var payment = {};
  payment = payment_1.default;
  creditCard_1.fixCreditCardsPatterns(payment);
  var issuer = payment.fns.cardType(value);
  var clearValue = exports.onlyNumbers(value);
  var nextValue = clearValue;

  switch (issuer) {
    case 'amex':
      nextValue = clearValue.slice(0, 15);
      break;

    case 'dinersclub':
      nextValue = clearValue.slice(0, 14);
      break;

    case 'maestro':
      if (clearValue.match(regularExpressions_1.maestroFirstPatternRegex)) {
        nextValue = clearValue.slice(0, 18);
      } else if (clearValue.match(regularExpressions_1.maestroSecondPatternRegex)) {
        nextValue = clearValue.slice(0, 19);
      }

      break;

    default:
      nextValue = clearValue.slice(0, 16);
      break;
  }

  return nextValue;
}

exports.formatCreditCardNumber = formatCreditCardNumber;

function formatCVC(cvcValue, cardNumber) {
  var clearValue = exports.onlyNumbers(cvcValue);
  var maxLength = 3;

  if (cardNumber) {
    var issuer = payment_1.default.fns.cardType(cardNumber);
    maxLength = issuer === 'amex' ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

exports.formatCVC = formatCVC;

function formatExpirationDate(value) {
  var clearValue = exports.onlyNumbers(value);

  if (clearValue.length >= 3) {
    return "".concat(clearValue.slice(0, 2), "/").concat(clearValue.slice(2, 4));
  }

  return clearValue;
}

exports.formatExpirationDate = formatExpirationDate;

exports.normalizeDocumentNumber = function (docTypeId) {
  return function (value, prevValue, allValues) {
    var tempValue = exports.noInitialZero(value);
    var type = allValues.docType || allValues.document_type || allValues["id".concat(docTypeId)];

    switch (type) {
      case 'dni':
        return exports.numberMaxLength(8)(tempValue);

      case 'cuit':
        return exports.numberMaxLength(11)(tempValue);

      case 'provincial_ci':
        return exports.numberMaxLength(8)(tempValue);

      case 'identity_card':
        return exports.numberMaxLength(8)(tempValue);

      case 'enlistment_book':
        return exports.numberMaxLength(8)(tempValue);

      case 'civic_notebook':
        return exports.numberMaxLength(8)(tempValue);

      case 'passport':
        return exports.numberMaxLength(9)(tempValue);

      case 'cert_of_document_in_proccess':
        return exports.numberMaxLength(11)(tempValue);

      default:
        return exports.numberMaxLength(11)(tempValue);
    }
  };
};

exports.removeWhitespaces = function (value) {
  return value ? value.replace(regularExpressions_1.whitespacesRegex, '') : value;
};

exports.noConsecutiveSpaces = function (value) {
  return value ? value.replace(regularExpressions_1.doubleWhitespacesRegex, '') : value;
};

exports.noInitialZero = function (value) {
  return !value ? value : value.replace(/^0/g, '');
};

exports.normalizeUpperCase = function (value) {
  return value ? value.toUpperCase() : value;
};

exports.normalizeAll = function (normalizers) {
  return function (value, previousValue, allValues, previousAllValues) {
    var i = 0;
    var normalizersLength = normalizers.length;
    var currentValue = value;

    while (i < normalizersLength) {
      var currentNormalizer = normalizers[i];

      if (typeof currentNormalizer === 'function') {
        currentValue = currentNormalizer(currentValue, previousValue, allValues, previousAllValues);
      }

      i += 1;
    }

    return currentValue;
  };
};

function dateToString(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
  var year = date.getYear() + 1900;
  var month = "0".concat(date.getMonth() + 1).substr(-2);
  var day = "0".concat(date.getDate()).substr(-2);
  format = format.replace('YYYY', year);
  format = format.replace('MM', month);
  format = format.replace('DD', day);
  return format;
}

exports.dateToString = dateToString;

exports.changeCase = function (s, options) {
  if (options.from === 'snake' && options.to === 'camel') {
    return s.replace(/(_\w)/g, function (m) {
      return m[1].toUpperCase();
    });
  }

  return s;
};

exports.withoutPaste = function (value, previousValue) {
  var valueLength = value.length;
  var previousValueLength = previousValue ? previousValue.length : 0;

  if (valueLength > 1 && previousValueLength === 0) {
    return undefined;
  }

  if (valueLength === 1 && previousValueLength === 0 || value.substring(0, valueLength - 1) === previousValue || valueLength < previousValueLength || valueLength - previousValueLength === 1) {
    return value;
  }

  return previousValue;
};

exports.onlyLettersAndNumbers = function (value) {
  return !value ? value : value.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]/g, '');
};

exports.maxLength = function (length) {
  return function (value) {
    return !value ? value : value.slice(0, length);
  };
};

exports.cuitFormatter = function (value) {
  if (!value) return value;
  var onlyNums = exports.numberMaxLength(11)(value);

  var valueArray = _toConsumableArray(onlyNums);

  if (valueArray.length > 2) {
    valueArray.splice(2, 0, '-');
  }

  if (valueArray.length > 11) {
    valueArray.splice(11, 0, '-');
  }

  return valueArray.join('');
};

var NORMALIZE_UTILS = {
  normalizeNumberWithDecimalsInput: exports.normalizeNumberWithDecimalsInput,
  padTwo: exports.padTwo,
  onlyNumbers: exports.onlyNumbers,
  numbersWithDecimals: exports.numbersWithDecimals,
  normalizeName: exports.normalizeName,
  onlyLettersAndSpaces: exports.onlyLettersAndSpaces,
  onlyLetters: exports.onlyLetters,
  normalizeDate: exports.normalizeDate,
  normalizeAccount: exports.normalizeAccount,
  normalizeLowerCase: exports.normalizeLowerCase,
  numberMaxLength: exports.numberMaxLength,
  withoutNumbers: exports.withoutNumbers,
  formatCreditCardNumber: formatCreditCardNumber,
  formatCVC: formatCVC,
  formatExpirationDate: formatExpirationDate,
  normalizeDocumentNumber: exports.normalizeDocumentNumber,
  removeWhitespaces: exports.removeWhitespaces,
  noConsecutiveSpaces: exports.noConsecutiveSpaces,
  noInitialZero: exports.noInitialZero,
  normalizeUpperCase: exports.normalizeUpperCase,
  normalizeAll: exports.normalizeAll,
  dateToString: dateToString,
  changeCase: exports.changeCase,
  withoutPaste: exports.withoutPaste,
  onlyLettersAndNumbers: exports.onlyLettersAndNumbers,
  maxLength: exports.maxLength,
  cuitFormatter: exports.cuitFormatter
};
exports.default = NORMALIZE_UTILS;